import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

/**
 * Langue initiale : préférence mémorisée (sélecteur Zifek), sinon navigateur,
 * sinon français (langue de référence de la plateforme).
 */
function getInitialLang(): string {
  try {
    const stored = localStorage.getItem('zifek_lang');
    if (stored) return stored;
  } catch { /* stockage indisponible */ }
  const nav = typeof navigator !== 'undefined' && navigator.language ? navigator.language.slice(0, 2) : '';
  return nav || 'fr';
}

i18n.use(initReactI18next).init({
  lng: getInitialLang(),
  fallbackLng: 'fr',
  debug: false,
  resources: messages,
  // Les clés Zifek sont « plates » et contiennent un point (ex : « dash.dashboard »).
  // On désactive donc le séparateur de clés pour que les correspondances soient exactes.
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;